import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormCurrencyField } from '_components/_core';

function FormDateFromToField({
  label,
  fromName,
  fromPlaceholder,
  toName,
  toPlaceholder,
  className,
}) {
  const defaultClass = 'd-flex flex-column justify-content-center align-items-start';

  const leftInputStyleProps = {
    fontWeight: 500,
    borderColor: '#d5dcec',
    minHeight: 32,
    maxHeight: 32,
    backgroundColor: '#fff',
    border: '1px solid #E8E7EA',
    borderRadius: '8px',
    width: '100%',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  };

  const rightInputStyleProps = {
    fontWeight: 500,
    borderColor: '#d5dcec',
    minHeight: 32,
    maxHeight: 32,
    backgroundColor: '#fff',
    border: '1px solid #E8E7EA',
    borderRadius: '8px',
    width: '100%',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: 0,
  };

  return (
    <div className={classNames(defaultClass, className)}>
      <span style={{ color: '#17212E', fontSize: '0.8rem', fontWeight: 600 }}>
        {label}
      </span>
      <div className="d-flex justify-content-center align-items-start mt-1">
        <FormCurrencyField
          name={fromName}
          placeholder={fromPlaceholder}
          inputStyleProps={leftInputStyleProps}
        />
        <FormCurrencyField
          name={toName}
          placeholder={toPlaceholder}
          inputStyleProps={rightInputStyleProps}
        />
      </div>
    </div>
  );
}

FormDateFromToField.defaultProps = {
  label: 'De - Até',
  fromPlaceholder: 'De:',
  toPlaceholder: 'Até:',
  className: '',
};

FormDateFromToField.propTypes = {
  label: PropTypes.string,
  fromName: PropTypes.string.isRequired,
  fromPlaceholder: PropTypes.string,
  toName: PropTypes.string.isRequired,
  toPlaceholder: PropTypes.string,
  className: PropTypes.string,
};

export default FormDateFromToField;
